import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'device-catalog',
  children: {
    variantId: {
      path: ':variantId',
    },
  },
} as const satisfies Location
